import { render, staticRenderFns } from "./PackagePopup.vue?vue&type=template&id=0a7338a6&scoped=true&"
import script from "./PackagePopup.vue?vue&type=script&lang=js&"
export * from "./PackagePopup.vue?vue&type=script&lang=js&"
import style0 from "./PackagePopup.vue?vue&type=style&index=0&id=0a7338a6&lang=scss&scoped=true&"
import style1 from "./PackagePopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7338a6",
  null
  
)

export default component.exports